// extracted by mini-css-extract-plugin
export default {"wrap":"zI-z","subtitle":"AI-z","contentWrap":"BI-z","imgWrap":"CI-z","heading":"DI-z","copy":"EI-z"};